// Kept it same as the api endpoint funnel type.
export enum Funnel {
  Air = "Air",
  Ground = "Ground",
  Lodging = "Lodging",
  Package = "Package",
  Activities = "Activities",
  Trips = "Trips",
}
